export const ID = '0df501da-eded-4a41-a8de-d292110b5b1d';

export const NAME = 'Header Logo';

export const CONTEXT_MENU_MESSAGE = 'Upload and edit this widget in';
export const CONTEXT_MENU_LINK_TEXT = 'site branding';
